import SubCollectionSection from './SubCollectionSection'

export default SubCollectionSection
